import React from 'react';
import './Page.css';

const KYCPolicy = () => {
  return (
    <div className="page-content">
      <div className="container">
        <h1>KYC and AML Policy</h1>
        
        <p>We are dedicated to upholding the highest levels of compliance with regulations designed to combat financial crimes, such as money laundering and terrorist financing. Our Know Your Customer (KYC) and Anti-Money Laundering (AML) policy specifies our processes and requirements for identifying and verifying customers.</p>
        
        <h2>1. Customer Identification</h2>
        
        <h3>1.1. Identity Verification</h3>
        <p>All customers must present valid identification documents for identity verification. Acceptable forms include government-issued photo IDs such as passports, driver's licenses, or national identity cards.</p>
        
        <h3>1.2. Proof of Address</h3>
        <p>Along with identity verification, customers are required to provide proof of their residential address. Acceptable documents may include utility bills, bank statements, or official government documents that display the customer's name and address.</p>
        
        <h2>2. Customer Due Diligence</h2>
        
        <h3>2.1. Enhanced Due Diligence (EDD)</h3>
        <p>We perform enhanced due diligence for customers classified as high-risk, based on factors like transaction volume, geographical location, or other pertinent criteria.</p>
        
        <h3>2.2. Source of Funds</h3>
        <p>We may request information about the source of funds for certain transactions to ensure compliance with AML regulations.</p>
        
        <h2>3. Transaction Monitoring</h2>
        <p>Our compliance team carries out manual reviews of transactions flagged by our monitoring systems or identified through other means to evaluate potential risks and ensure adherence to AML regulations.</p>
        
        <h2>4. Reporting Obligations</h2>
        
        <h3>4.1. Suspicious Activity Reporting</h3>
        <p>We are required to report any suspicious transactions or activities to the appropriate authorities in compliance with applicable regulations.</p>
        
        <h3>4.2. Cooperation with Regulatory Authorities</h3>
        <p>We fully cooperate with regulatory agencies and law enforcement in investigations related to money laundering, terrorist financing, or other financial crimes.</p>
        
        <h2>5. Customer Communication</h2>
        
        <h3>5.1. Transparency</h3>
        <p>We aim to maintain open and clear communication with our customers regarding our KYC and AML policies, including any updates or modifications to these policies.</p>
        
        <h3>5.2. Customer Support</h3>
        <p>Our customer support team is available to assist customers with any inquiries or concerns related to KYC and AML compliance.</p>
        
        <h2>6. Compliance Training</h2>
        
        <h3>6.1. Employee Training</h3>
        <p>Our employees receive regular training on KYC and AML compliance to ensure they understand their duties and responsibilities under relevant regulations.</p>
        
        <h2>7. Privacy and Data Protection</h2>
        
        <h3>7.1. Data Security</h3>
        <p>We are committed to protecting the privacy and security of customer information in accordance with relevant data protection laws and regulations.</p>
        
        <h3>7.2. Data Retention</h3>
        <p>Information collected for KYC purposes is retained in compliance with applicable laws and regulations and is used solely for the purpose of fulfilling our regulatory obligations.</p>
        
        <div className="warning-box">
          <p><strong>By using our platform, customers consent to comply with our KYC and AML policies. Failure to provide the requested information or to adhere to our procedures may result in restrictions on account activities or account closure. We reserve the right to update or revise our KYC and AML policies as needed to maintain compliance with evolving regulatory requirements.</strong></p>
        </div>
      </div>
    </div>
  );
};

export default KYCPolicy;
